import { Route, Routes } from 'react-router-dom';
import WEAEntryScreen from '../screens/WEA/WEAEntryScreen';
import WEAForgotPasswordScreen from '../screens/WEA/WEAForgotPasswordScreen';
import WEAHomeScreen from '../screens/WEA/WEAHomeScreen';
import WEALoginScreen from '../screens/WEA/WEALoginScreen';
import WEATeacherMembershipProgramDetailsScreen from '../screens/WEA/WEAProgramDetailScreen';
import WEAReferralRewardDetailsScreen from '../screens/WEA/WEAReferralRewardDetailsScreen';
import WEARegisterScreen from '../screens/WEA/WEARegisterScreen';
import WEASuccessRegScreen from '../screens/WEA/WEASuccessRegScreen';
import WEATeacherReferralOverviewScreen from '../screens/WEA/WEATeacherReferralOverviewScreen';
import WEAAccountInfoScreen from '../screens/WEA/WEAAccountInfoScreen';
import { WEASetDisplayNameScreen } from '../components/Molecules';
import { WEASetPasswordScreen } from '../components/Molecules';
import { WEASetEmailScreen } from '../components/Molecules';
import { WEASetUsernameScreen } from '../components/Molecules';
import { WEASetRegionScreen } from '../components/Molecules';
import { WEANotFound } from '../screens/WEA/WEANotFound';
import WEAProgramRedemptionScreen from '../screens/WEA/WEAProgramRedemption';

const WEARoute: React.FC = () => {
  return (
    <Routes>
      <Route path="/start" element={<WEAEntryScreen />} />
      <Route path="/login" element={<WEALoginScreen />} />
      <Route path="/forgot-password" element={<WEAForgotPasswordScreen />} />
      <Route
        path="/register"
        element={<WEARegisterScreen isPhoneSignup={false} />}
      />
      <Route path="/register/success" element={<WEASuccessRegScreen />} />
      <Route path="/" element={<WEATeacherMembershipProgramDetailsScreen />} />
      <Route path="/home" element={<WEAHomeScreen />} />
      <Route
        path="/referral-detail"
        element={<WEAReferralRewardDetailsScreen />}
      />
      <Route path="/referral" element={<WEATeacherReferralOverviewScreen />} />
      <Route
        path="/rewardRedemption/:id"
        element={<WEAProgramRedemptionScreen />}
      />
      <Route path="/account" element={<WEAAccountInfoScreen />} />
      <Route
        path="/account/display-name"
        element={<WEASetDisplayNameScreen />}
      />
      <Route path="/account/password" element={<WEASetPasswordScreen />} />
      <Route path="/account/email" element={<WEASetEmailScreen />} />
      <Route path="/account/username" element={<WEASetUsernameScreen />} />
      <Route path="/account/region" element={<WEASetRegionScreen />} />
      <Route path="/reset-password" element={<WEAForgotPasswordScreen />} />
      <Route path="*" element={<WEANotFound />} />
    </Routes>
  );
};

export default WEARoute;
